module.exports = __webpack_public_path__ + "static/media/reshot-icon-arrow-down-CXRGBZP93T.1b0cd021.svg";